export interface AppVersionResponse {
  release: string;
  commitHash: string;
}

export const getAppVersion = async (): Promise<AppVersionResponse> => {
  const response = await fetch(`${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/version`);
  return await response.json();
};
